module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/vocabulary/components/add-concept-version.component.scss
// module id = ./src/app/vocabulary/components/add-concept-version.component.scss
// module chunks = main